import React, { useState } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import styles from '../css/loginPage.module.css'; // Import CSS module

const SignInPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Get the redirect path from state, or default to home
      const from = location.state?.from?.pathname || '/';
      navigate(from);
    } catch (error) {
      setError('Invalid email or password');
      console.error(error);
    }
  };


  return (
    <div className={styles.signInContainer}>
      <div className={styles.signInCard}>
        <h2 className={styles.signInTitle}>Sign In</h2>
        <form onSubmit={handleSignIn}>
          <div className={styles.inputGroup}>
            <input
              type="email"
              className={styles.signInInput}
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={styles.inputGroup}>
            <input
              type="password"
              className={styles.signInInput}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className={styles.signInButton}>Sign In</button>
          <NavLink to="/forgot-password" exact activeClassName={styles.forgotPasswordButton}>
          Forgot Password ?
              </NavLink>
        </form>
        {error && <p className={styles.errorMessage}>{error}</p>}
      </div>
    </div>
  );
};

export default SignInPage;